var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardSwiperItem',{attrs:{"per-view":_vm.perView,"gap":_vm.gap}},[_c('AdaptiveCard',{attrs:{"ratio":_vm.ratio,"image":_vm.image,"href":_vm.href,"image-type":_vm.imageType}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }